const imageLoading = (() => {

    const initBlock = img => {
        const windowHeight = window.innerHeight;
        if (img.getBoundingClientRect().top <= windowHeight) {
            img.setAttribute('loading', 'eager');
        }
    };

    return {initBlock};
})();

document.addEventListener("DOMContentLoaded", (event) => {
    document.querySelectorAll('img[loading="lazy"]').forEach(item => imageLoading.initBlock(item));
});